'use client';

import React from 'react';
import ContactForm from './ContactForm';
import FAQSection from './FAQSection';

const ContactInteractive = () => {
  return (
    <>
      {/* Contact Form Section */}
      <section className="py-16 bg-background">
        <div className="max-w-4xl mx-auto px-4 md:px-6 lg:px-8">
          <ContactForm />
        </div>
      </section>

      {/* FAQ Section */}
      <FAQSection />
    </>
  );
};

export default ContactInteractive;